import {getAllTenantsInfo,getTenants} from '../Api/Index';
import { useQuery, useQueryClient, useMutation } from "react-query";



const useGetAllTenantsInfo=()=>{
    return useQuery(['getAlltenantsInfo'],getAllTenantsInfo,{
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        
        onError:(err)=>{
        // console.log( err)
        },
        onSuccess:(data)=>{
            let rawdata=data?.data?.data;
            
        // console.log(data)
        }
        ,
        select:(data)=>{
            let rawdata=data?.data?.data;
             return rawdata
        }
    })
}

const useGetTenants = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => getTenants(data),
    onSuccess: (data) => {
        let rawData=data?.data.data;
        let transformed=rawData.map((item:any,i:number)=>{
            let{id,name}=item
        return {key:name,value:id}
        })
        return transformed
    },
  });
};

export{
    useGetAllTenantsInfo,
    useGetTenants
}